<script>

import CropperImg from "@/components/CropperImg";

export default {
  name: "Userinfo",
  components: {CropperImg},
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      show: false,
      form: {
        username: "",
        avatar: "https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png"
      }
    }
  },
  watch: {
    visible(val) {
      console.log("切换显示", val)
      this.show = val
      this.getUserinfo()
    }
  },
  methods: {
    getUserinfo() {
      console.log("加载用户信息")
      this.$cloud.get('/account/index').then(res => {
        console.log("用户信息", res)
        this.form.username = res.username
        this.form.avatar = res.avatar
      })
    },
    handleClose() {
      console.log("关闭")
      this.show = false
      this.$emit('update:visible', false)
    },
    handleEditAvatar({data, close}) {
      console.log("上传头像", data, close)
      this.$cloud.post('/account/update', {avatar: data.url}).then(() => {
        close();
        this.getUserinfo()
      }).catch(() => {
        close();
      })
    },
    handleEditUsername() {
      this.$prompt('请输入用户姓名', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        beforeClose: (action, instance, done) => {
          if (action === 'confirm') {
            instance.confirmButtonLoading = true;
            instance.confirmButtonText = '保存中...';
            console.log('inputValue', instance.inputValue)
            this.$cloud.post('/account/update', {username: instance.inputValue}).then(() => {
              done();
              instance.confirmButtonLoading = false;
            }).catch(() => {
              done();
              instance.confirmButtonLoading = false;
            })
          } else {
            done();
          }
        }
      }).then(({value}) => {
        this.$message({
          type: 'success',
          message: '保存成功'
        });
        this.getUserinfo()
      })
    }
  }
}
</script>

<template>
  <el-dialog title="个人信息" :visible.sync="show" @close="handleClose" width="400px" append-to-body>
    <el-form class="m-2 pb-2" ref="form" :model="form" label-width="110px">
      <el-form-item label="用户头像">
        <div class="flex">
          <div>
            <el-avatar :size="120" :src="form.avatar"></el-avatar>
          </div>
          <div class="ml-2">
            <CropperImg @finish="handleEditAvatar">
              <el-button>更换头像</el-button>
            </CropperImg>
          </div>
        </div>

      </el-form-item>
      <el-form-item label="用户姓名">
        {{ form.username }}
        <el-button class="ml-2" @click="handleEditUsername">修改</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<style scoped>

</style>
